// extracted by mini-css-extract-plugin
module.exports = {"section":"_2fZg4c9sPu","header":"_5sdj-RUEaw","notice":"_1h-T6lqSsd","reminder-inline":"_17sWAq-pQC"};